import { useEffect } from 'react';
import Script from 'next/script';

import { reportAccountDrift } from './chat-account';
import { callWidgetWhenReady, visibilityCommand, whenWidgetReady } from './chat-commands';
import { enforceChatHidden } from './chat-hidden-enforcer';
import { useChatHidden } from './use-chat-hidden';

const VendorLoaderSrc = '/commversion-chat-widget.js';

const applyVisibilityRules = (isHidden) => {
  const stopWaiting = callWidgetWhenReady(visibilityCommand(isHidden));

  if (!isHidden) return stopWaiting;

  const stopEnforcing = enforceChatHidden();

  return () => {
    stopWaiting();
    stopEnforcing();
  };
};

const ChatWidget = () => {
  const isHidden = useChatHidden();

  useEffect(() => applyVisibilityRules(isHidden), [isHidden]);

  useEffect(() => whenWidgetReady(reportAccountDrift), []);

  return <Script id="commversion-chat-widget" src={VendorLoaderSrc} strategy="afterInteractive" />;
};
export default ChatWidget;
